/* r3 2026-09-23: the header/announcement-bar padding logic that lived here (DOM ready + setTimeout 1000/1500 ms + a
   handler on every scroll event, each write shifting the page) moved to snippets/rr-header-offset.liquid, which sets the
   same value once before first paint. The okeReviews "ratingCountss" rewrite was removed: that selector matches nothing. */
$(document).ready(function () {
  $(".happy-customer")
    .find(".quote-text")
    .hover(function () {
      $(this).context.scrollHeight > $(this).context.clientHeight &&
      !$(this).hasClass("showContent")
        ? $(this).addClass("showContent", 900)
        : $(this).hasClass("showContent") &&
          $(this).removeClass("showContent", 900);
    });
});
